import VueRouter from 'vue-router'
import Vue from 'vue'
Vue.use(VueRouter)

import login from './views/login.vue'
import loginSSO from './views/loginSSO.vue'
import home from './views/home.vue'
import preApprovalLogin from './views/preApprovalLogin/Index.vue'
//根页面
import global from './views/global.vue'

let routes = [
  // {
  //   path: '/',
  //   component: preApprovalLogin,
  //   name: '登录',
  //   children: [
  //     {
  //       path: '/login',
  //       component: preApprovalLogin,
  //       name: '登录',
  //     },
  //   ],
  // },
  {
    path: '/',
    component: loginSSO,
    name: '登录',
    children: [
      {
        path: '/login',
        component: loginSSO,
        name: '登录',
      },
    ],
  },
  {
    path: '/terms',
    component: require('@/views/terms.vue').default,
  },
  {
    path: '/kycFileCN',
    component: require('@/views/kycFile/kycFileCN.vue').default,
    name: 'kyc建档',
  },
  {
    path: '/childEkycPortal/*',
    name: 'ekycPortal',
    component: require('@/views/ekycPortal/ekycPortal.vue').default,
  },
  {
    path: '/companyChoose',
    component: require('@/views/companyChooseAlert/companyChooseAlert.vue')
      .default,
    name: '选择企业',
  },
  {
    path: '/logoutPage',
    component: require('@/views/logoutPage.vue').default,
    name: '退出登录',
  },
  {
    path: '/contract',
    name: 'contract',
    component: require('@/views/contract/index.vue')
      .default,
  },
  {
    path: '/jumpingLoading',
    component: require('@/views/jumpingLoading/jumpingLoading.vue').default,
    name: '免密登录',
},
  {
    path: '/home',
    component: home,
    name: '主页',
    children: [
      // {
      //   path: '/',
      //   component: global,
      // },
      {
        path: '/bigHome',
        component: global,
        name: '大首页',
      },
      {
        path: '/child-iDDPortal/*',
        name: 'iDDPortal',
        component: require('@/views/iDDPortal/iDDPortal.vue').default,
      },
      {
        path: '/childUserPt/*',
        name: 'iDDPortal',
        component: require('@/views/cbfUserPortal/cbfUserPortal.vue').default,
      },
      {
        path: '/childiDDUserPortal/*',
        name: 'iDDUserPortal',
        component: require('@/views/iDDUserPortal/iDDUserPortal.vue').default,
      },
      {
        path: '/childDocExchange/*',
        name: 'docPortal',
        component: require('@/views/docPortal/docPortal.vue').default,
      },
      {
        path: '/childScbPortal/*',
        name: 'scbPortal',
        component: require('@/views/scbPortal/scbPortal.vue').default,
      },
      {
        path: '/child-efinancePortal/*',
        name: 'eFinancePortal',
        component: require('@/views/efinancePortal/efinancePortal.vue').default,
      },
      {
        path: '/child-marketplacePortal/*',
        name: 'marketplacePortal',
        component: require('@/views/marketplacePortal/marketplacePortal.vue')
          .default,
      },
      {
        path: '/child-digipoPortal/*',
        name: 'digipoPortal',
        component: require('@/views/digipoPortal/digipoPortal.vue').default,
      },
      {
        path: '/childDocCheckPortal/*',
        name: 'docCheckPortal',
        component: require('@/views/docCheckPortal/docCheckPortal.vue').default,
      },
      {
        path: '/child-accountSettingPortal/*',
        name: 'accountSettingPortal',
        component: require('@/views/accountSettingPortal/accountSettingPortal.vue')
          .default,
      },
      {
        path: '/main-productCenter',
        name: 'productCenter',
        component: require('@/views/productCenter/index.vue').default,
      },
      {
        path: '/exportDrawbackKyc',
        name: 'exportDrawbackKyc',
        component: require('@/views/exportDrawbackKyc/index.vue').default,
      },
      {
        path: '/CommKycFile',
        name: 'commKycFile',
        component: require('@/views/CommKycFile/kycFile.vue').default,
      },
    ],
  },
  {
    path: '/AdvanceCredit',
    name: 'AdvanceCredit',
    component: require('@/views/preApprovalLogin/Index.vue').default,
  },
]

const router = new VueRouter({
  // mode:'history',
  routes,
})
let count = 0
function isLogin(from) {
  return new Promise(async(resolve) => {
    // 路由切换时检查登录状态
    if (window.vm && window.vm.$sso) {
      var islogin = await window.vm.$sso.checkLogin()
      // 防重，排除登录页
      if (!islogin && count == 0 && from.path !== '/login') {
        Vue.prototype.$alert('User not logged in!', window.vm.$t('login.tips'), {
          confirmButtonText: window.vm.$t('login.loginAgain'),
          callback: action => {
            const redirect = router.currentRoute.path
            const query = router.currentRoute.query
            if (
              redirect === '/childDocExchange/pendingTask' ||
              redirect === '/childDocExchange/transactionDetails'
            ) {
              router.replace({
                path: '/login',
                query: { redirect, ...query },
              })
            } else {
              router.replace('/login')
            }
            count++
            setTimeout(() => {
              count = 0
            }, 5000)
          },
        })
        return resolve(false)
      }
    }
    return resolve(true)
  })
}
router.beforeEach(async(to, from, next) => {
  // 暂时注释掉，后续需要封装该方法
  // const isLoginFlag = await isLogin(from)
  // if (!isLoginFlag) return
  
  if (to.path == '/childDocExchange/transactionDetails') {
    console.log('beforeEach--to.path', to.path)
    next()
  }
  if (from.path == '/login' && from.query.isReFlag == 1) {
    // console.log(' login--isReFlag', )
    // console.log('from.query',from.query)
    let { refer, lang, isReFlag, id } = from.query
    next({
      path: '/childDocExchange/transactionDetails',
      query: { refer, lang, isReFlag, id },
    })
  } else {
    next()
  }
})
export default router
